import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '../design/components/cr-chip.js';
import { html, nothing } from 'lit';

export const CrDataWarning = (active?: boolean) => {
  if (!active) return nothing;

  return html` <style>
      @keyframes fade {
        0%,
        100% {
          opacity: 0.5;
        }
        50% {
          opacity: 1;
        }
      }
    </style>
    <cr-chip
      tone="error"
      ${css({
        color: 'white',
        minHeight: '1rem',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '10rem',
        display: 'flex',
      })}
      ${acss({
        opacity: 1,
        animation: 'fade 2s infinite',
      })}
    >
      <cr-text
        ${css({
          fontSize: '1.1rem',
          padding: '5px',
        })}
      >
        Ungespeicherte Daten
      </cr-text>
    </cr-chip>`;
};
